// AI进宝分享会话
export default {
  path: '/aiChat/share',
  name: 'aiChatShare',
  component: () => import(/* webpackChunkName: 'ai-chat-share' */ '@/pages/aiAssistant/chatMode/chatShare.vue'),
  meta: {
    requireAuth: false,
    hiddenNav: true,
    localeModules: [
      'aiChat',
      'aiAssistant',
      'researchEditor',
      'aiChatConstants',
      'aiTools',
      'openClaw',
      'cloudDocument',
      'report',
      'summary'
    ]
  }
};
